import React from 'react';
import { Building2, Factory, Home, Droplets, Flame, Wind } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const ICON_MAP = { Building2, Factory, Home, Droplets, Flame, Wind };

const Applications = ({ applications = [] }) => {
  if (!applications || applications.length === 0) return null;

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-sm font-semibold text-blue-600 uppercase tracking-wider mb-3">Applications & Services</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Serving <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-800">Diverse Industries</span>
          </h3>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-500 to-yellow-600 mx-auto mb-6"></div>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            We cater to contractors, MEP consultants, builders, and end-users across various sectors
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {applications.map((app, index) => {
            const IconComponent = ICON_MAP[app.icon] || Building2;
            const color = index % 2 === 0 ? 'blue' : 'yellow';
            return (
              <Card key={index} className="border-2 hover:border-blue-200 transition-all hover:shadow-xl group overflow-hidden">
                <div className={`h-2 bg-gradient-to-r ${
                  color === 'blue' ? 'from-blue-500 to-blue-700' : 'from-yellow-500 to-yellow-700'
                }`}></div>
                <CardContent className="p-6">
                  <div className={`w-14 h-14 bg-gradient-to-br ${
                    color === 'blue' ? 'from-blue-500 to-blue-600' : 'from-yellow-500 to-yellow-600'
                  } rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform shadow-md`}>
                    <IconComponent className="text-white" size={28} />
                  </div>
                  <h4 className="text-xl font-bold text-gray-900 mb-3">{app.title}</h4>
                  <p className="text-gray-600">{app.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Applications;
